import React from 'react';
import cn from 'classnames';

import Link from '../../../common/ui/Link';
import Button from '../../../common/ui/Button';
import Modal from '../../../common/ui/Modal';
import { getScheduledCancellationDate } from '../../../../utils/dates';

import styles from './styles.module.scss';

const SuccessModal = ({
  isOpen,
  cancellationType,
  onClose,
  returnLabel,
  nextChargeDate,
}) => {
  const handleDownloadBtn = () => {
    window.open(returnLabel, '_blank');
  };
  const scheduledCancellationDAte =
    getScheduledCancellationDate(nextChargeDate);
  const description =
    cancellationType === 'immediate' ? (
      <>Your cancellation has been confirmed. Here's what to do next:</>
    ) : (
      <>
        Your cancellation has been scheduled for{' '}
        <span>{scheduledCancellationDAte}</span>. Here's what to do next:
      </>
    );
  return (
    <Modal
      preventClosing={true}
      isOpen={isOpen}
      onClose={onClose}
      className={styles.successModal}
      showSupportFooter={true}
    >
      <h3 className={cn('h3', styles.title)}>Subscription cancelled</h3>
      <div className={styles.description}>{description}</div>
      <ul>
        <li>
          <p>
            <b>1.</b> Download your{' '}
            <Link target="_blank" colorType={'orange'} href={returnLabel}>
              Return Label
            </Link>
          </p>
          <span>We've also sent a copy to your email</span>
        </li>
        <li>
          <p>
            <b>2.</b> Pack and ship your device
          </p>
          <span>
            Use the return label provided and include the original device box
          </span>
        </li>
        <li>
          <p>
            <b>3.</b> Return within 7 days
          </p>
          <span>
            Send back within 7 days to avoid additional charges. You can track
            your return status anytime in your account dashboard.
          </span>
        </li>
      </ul>
      <Button onClick={handleDownloadBtn} className={styles.button}>
        Download the Return Label
      </Button>
    </Modal>
  );
};
export default SuccessModal;
